import concat from 'lodash/concat';
import { OptionType } from '../types';
import { DetailedOptionType } from '../types';

export const getItemOptions = (option: DetailedOptionType) => {
    return concat(option.parents, option, option.children).filter(Boolean);
};

export const testIsDetailed = (
    option: OptionType | DetailedOptionType
): option is DetailedOptionType => {
    const detailedOption = option as DetailedOptionType;
    return Boolean(
        detailedOption.name && detailedOption.children && detailedOption.parents
    );
};

export const testItemHasChildren = (option: DetailedOptionType) => {
    return Boolean(option?.children?.length);
};
